<template>
  <div data-v-d27b4d60="" data-v-e5781868="" class="myAccount mainContent top50">
    <div data-v-d27b4d60="" class="content">
      <div data-v-d27b4d60="" class="top zeroLevel">
        <div data-v-d27b4d60="" class="box" style="width: 100%">
          <div data-v-d27b4d60="" class="box-inner">
            <div data-v-d27b4d60="" class="username">
              <div data-v-d27b4d60="" class="text">
                尊敬的 <span data-v-d27b4d60="" style="margin-left: 5px">{{ $store.state.userInfo.username }}</span>
              </div>
            </div>
            <div data-v-d27b4d60="" class="bottom-section">
              <div data-v-d27b4d60="" class="group">
                <div data-v-d27b4d60="" class="inputGroup">
                  <label data-v-d27b4d60="">CNY账户</label>
                  <input data-v-d27b4d60="" type="text" :value="$store.state.userInfo.balance" disabled />
                  <span data-v-d27b4d60="" class="current"
                    ><svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon greenDot">
                      <use data-v-338e1447="" xlink:href="#icon-greenDot"></use>
                    </svg>
                    使用中
                  </span>
                </div>
                <div data-v-d27b4d60="" class="help">
                  <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon iconHelp">
                    <use data-v-338e1447="" xlink:href="#icon-iconHelp"></use>
                  </svg>
                  <div data-v-d27b4d60="" class="message">请选择一种资产进行游戏</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-d27b4d60="" class="nav">
        <ul data-v-d27b4d60="">
          <a href="javascript:void(0);" @click="$parent.goNav('/accountSetting')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconSetting">
                <use data-v-338e1447="" xlink:href="#icon-iconSetting"></use>
              </svg>
              账户设置
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/myWallet')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconWallet">
                <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
              </svg>
              我的钱包
            </li>
          </a>
                              <a href="javascript:void(0);" @click="$parent.goNav('/transfer')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconWallet">
                <use data-v-338e1447="" xlink:href="#icon-iconWallet"></use>
              </svg>
              转账
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/fundingRecords')">
            <li data-v-d27b4d60="" class="">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconRecord">
                <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
              </svg>
              资金记录
            </li>
          </a>
          <a href="javascript:void(0);" @click="$parent.goNav('/activityRecord')">
            <li data-v-d27b4d60="" class="active">
              <svg data-v-338e1447="" data-v-d27b4d60="" aria-hidden="true" class="svg-icon icon iconRecord">
                <use data-v-338e1447="" xlink:href="#icon-iconRecord"></use>
              </svg>
              活动及代理
            </li>
          </a>
        </ul>
      </div>
      <div data-v-119184d8="" data-v-d27b4d60="" class="fundingRecords">
        <div data-v-119184d8="" class="top">
          <div data-v-119184d8="" class="topTxt">
            <div data-v-119184d8="" class="menu">
              <span data-v-119184d8="" @click="changshowtype(0)" :class="showtype == 0 ? 'active' : ''"> 活动申请记录 </span>
            </div>
          </div>
          <div data-v-119184d8="" class="dcontent">
            <div data-v-119184d8="" class="recordDetails">
              <div data-v-119184d8="">
                <div data-v-2e25a862="" data-v-119184d8="" class="depositTable">
                  <div data-v-2e25a862="" class="thead">
                    <div data-v-2e25a862="" class="th">活动标题</div>
                    <div data-v-2e25a862="" class="th">申请时间</div>
                    <div data-v-2e25a862="" class="th">状态</div>
                  </div>
                  <div data-v-2e25a862="" class="recordList" v-if="dataList.length > 0">
                    <div data-v-11bca73b="" class="item" v-for="(item, index) in dataList" :key="index">
                      <div data-v-11bca73b="" class="set1">
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="" style="box-sizing: border-box; padding-left: 6px">{{ item.activity_name }}</span>
                        </div>
                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">{{ item.created_at }}</span>
                        </div>

                        <div data-v-11bca73b="" class="td">
                          <span data-v-11bca73b="">
                            <span class="green">{{ statuType[item.state] }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-2e25a862="" class="recordList" v-if="dataList.length == 0">
                    <div data-v-2e25a862="" class="noRecord">
                      <div data-v-2e25a862="" class="img"></div>
                      <div data-v-2e25a862="" class="txt">暂无记录</div>
                    </div>
                  </div>
                </div>
              </div>

              <div data-v-2fe78b6a="" class="controls" v-if="showData.total">
                <el-pagination @current-change="getData" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="showData.total"> </el-pagination>
              </div>
            </div>

            <div data-v-119184d8="" class="typeBox">
              <div data-v-119184d8="" class="box" v-if="$store.state.userInfo.isagent == 0">
                <div data-v-119184d8="" class="typeList">
                  <div data-v-119184d8="" class="rbox">
                    <label data-v-119184d8="" class="container">
                      <span data-v-119184d8="" class="txt"> <span style="color: yellow" @click="closeType">申请代理</span></span></label
                    >
                  </div>
                </div>
              </div>
                <div data-v-119184d8="" class="box" v-if="$store.state.userInfo.isagent == 1">
                <div data-v-119184d8="" class="typeList">
                  <div data-v-119184d8="" class="rbox">
                    <label data-v-119184d8="" class="container">
                      <span data-v-119184d8="" class="txt"> <span style="color: yellow" @click="$parent.getAgentLoginUrl">代理登录</span></span></label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-v-68239ec0="" class="mask setemail" v-if="shenqing">
        <div data-v-60d8da04="" data-v-68239ec0="" class="content">
          <div data-v-60d8da04="" class="backdrop">
            <div data-v-60d8da04="" class="popup popup2">
              <div data-v-60d8da04="" class="popHead">
                请求代理
                <a data-v-60d8da04="" class="popClose" @click="closeType"
                  ><svg data-v-338e1447="" data-v-60d8da04="" aria-hidden="true" class="svg-icon iconClose">
                    <use data-v-338e1447="" xlink:href="#icon-iconClose"></use></svg
                ></a>
              </div>
              <div data-v-60d8da04="" class="popContent">
                <form data-v-60d8da04="">
                  <div data-v-60d8da04="" class="warning message">
                    <svg data-v-338e1447="" data-v-60d8da04="" aria-hidden="true" class="svg-icon iconWarning">
                      <use data-v-338e1447="" xlink:href="#icon-iconWarning"></use>
                    </svg>
                    请填写真实申请信息，以便管理员审核代理信息！
                  </div>
                  <div data-v-60d8da04="" class="popInputGroup">
                    <label data-v-60d8da04=""
                      ><svg data-v-338e1447="" data-v-60d8da04="" aria-hidden="true" class="svg-icon iconEmail icon">
                        <use data-v-338e1447="" xlink:href="#icon-iconRealName"></use></svg
                    ></label>
                    <input data-v-60d8da04="" :value="$store.state.userInfo.realname" type="text" disabled placeholder="请输入您的姓名" class="" />
                  </div>
                  <div data-v-60d8da04="" class="popInputGroup">
                    <label data-v-60d8da04=""
                      ><svg data-v-338e1447="" data-v-60d8da04="" aria-hidden="true" class="svg-icon iconEmail icon">
                        <use data-v-338e1447="" xlink:href="#icon-iconMobile"></use></svg
                    ></label>
                    <input data-v-60d8da04="" v-model="mobile" type="text" placeholder="请输入您的联系方式" class="" />
                  </div>
                  <div data-v-60d8da04="" class="popInputGroup">
                    <label data-v-60d8da04=""
                      ><svg data-v-338e1447="" data-v-60d8da04="" aria-hidden="true" class="svg-icon iconEmail icon">
                        <use data-v-338e1447="" xlink:href="#icon-registDate"></use></svg
                    ></label>
                    <input data-v-60d8da04="" v-model="apply_info" type="textarea" placeholder="请输入申请理由" class="" />
                  </div>
                  <div data-v-60d8da04="" class="popBtn buttonSolid" @click="isOk()">确定</div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activityRecord',
  data() {
    return {
      date: 1,
      type: 1,
      page: 1,
      api_type: '',

      statuType: ['0未约定', '待审核', '通过', '拒绝', '4未约定'],
      showData: {},
      dataList: [],
      showtype: 0,
      jisuan: 0,
      nojisuan: 0,
      mobile: null,
      apply_info: null,
      shenqing: false,
    };
  },
  created() {
    let that = this;
    that.getData();
  },
  methods: {
    closeType() {
      this.shenqing = !this.shenqing;
    },
    isOk() {
      let that = this;
      let info = { mobile: that.mobile, apply_info: that.apply_info };
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(that.mobile)) {
        that.$parent.showTost(0, '请输入正确手机号');
        return;
      }

      if (!that.apply_info) {
        that.$parent.showTost(0, '请输入申请理由');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/applyagentdo', info)
        .then(res => {
            that.$parent.showTost(1, res.message);
            that.shenqing = false;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changshowtype(val) {
      let that = this;
      if (val == that.showtype) {
        return;
      }
      that.page = 1;
      that.showtype = val;
      that.getData();
    },
    getData() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/activityApplyLog', {page:that.page})
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.dataList = res.data.data;
            that.showData = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
  watch: {
    date() {
      let that = this;
      that.page = 1;
      that.getData();
    },
    type() {
      let that = this;
      that.page = 1;
      that.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-06254e6a.f0cc50a1.css';
@import '../../../static/css/chunk-645a6edf.25ca78d5.css';
@import '../../../static/css/chunk-29b951e4.0bcca33f.css';
/* 解决fundingRecords区域黑色背景问题 - 完全覆盖深色样式 */
.fundingRecords[data-v-119184d8] {
    background: #ffffff !important; /* 强制白色背景 */
    color: #333333 !important;
    padding: 24px !important;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

/* 顶部区域样式修正 */
.fundingRecords .top[data-v-119184d8] {
    background: transparent;
}

.fundingRecords .topTxt[data-v-119184d8] {
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 16px;
    margin-bottom: 16px;
}

.fundingRecords .topTxt .menu span[data-v-119184d8] {
    color: #666666;
    padding: 8px 16px;
    border-radius: 6px;
}

.fundingRecords .topTxt .menu span.active[data-v-119184d8] {
    color: #2c6ecb;
    background-color: #eef4ff;
    font-weight: 500;
}

/* 内容区域布局修正 */
.fundingRecords .dcontent[data-v-119184d8] {
    display: flex;
    gap: 24px;
    margin-top: 16px;
}

/* 表格区域样式修正 */
.fundingRecords .recordDetails[data-v-119184d8] {
    flex: 1;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.depositTable .thead[data-v-2e25a862] {
    background: #f9f9f9 !important;
    display: flex;
    border-bottom: 1px solid #f0f0f0;
}

.depositTable .thead .th[data-v-2e25a862] {
    flex: 1;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666666 !important;
    font-weight: 500;
}

/* 列表项样式修正 */
.recordList .item[data-v-11bca73b] {
    background: #ffffff !important;
    border-bottom: 1px solid #f0f0f0;
}

.recordList .item .set1[data-v-11bca73b] {
    display: flex;
}

.recordList .item .set1 .td[data-v-11bca73b] {
    flex: 1;
    height: 56px;
    display: flex;
    align-items: center;
	font-weight: 700;
	top: 20px;
    justify-content: center;
    color: #333333 !important;
    transform: translateY(0) !important;
}

/* 无记录状态修正 */
.recordList .noRecord[data-v-2e25a862] {
    background: #ffffff !important;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px dashed #e0e0e0;
    border-radius: 8px;
}

.recordList .noRecord .txt[data-v-2e25a862] {
    color: #999999 !important;
    margin-top: 16px;
    font-size: 14px;
}

/* 右侧筛选框样式修正 */
.fundingRecords .typeBox[data-v-119184d8] {
    width: 240px;
}

.fundingRecords .typeBox .box[data-v-119184d8] {
    background: #f9f9f9 !important;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
}

.fundingRecords .typeBox .box .typeList[data-v-119184d8] {
    padding: 0;
}

.fundingRecords .rbox .container[data-v-119184d8] {
    color: #333333 !important;
    padding: 8px 0;
}

.fundingRecords .rbox .container .txt[data-v-119184d8] span {
    color: #ffab00 !important;
    cursor: pointer;
    transition: color 0.2s;
}

.fundingRecords .rbox .container .txt[data-v-119184d8] span:hover {
    color: #ff8c00 !important;
}

/* 分页控件修正 */
.controls[data-v-2fe78b6a] {
    padding: 20px;
    display: flex;
    justify-content: center;
    background: #ffffff;
}

.el-pagination button,
.el-pagination span:not([class*=suffix]) {
    color: #666666 !important;
}

.el-pagination .btn-next,
.el-pagination .btn-prev {
    border-color: #e0e0e0 !important;
    background: #ffffff !important;
}

.el-pagination .el-pager li {
    color: #666666 !important;
}

.el-pagination .el-pager li.active {
    color: #2c6ecb !important;
    font-weight: 500;
}

/* 状态标签样式 */
.green {
    color: #36b37e !important;
    background-color: #f0fdf4 !important;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 12px;
}

/* 解决Vue作用域样式穿透问题 */
::v-deep .fundingRecords[data-v-119184d8] {
    background: #ffffff;
}

::v-deep .fundingRecords[data-v-119184d8] * {
    color: #333333;
}
    
</style>



// WEBPACK FOOTER //
// src/components/mode/activityRecord.vue